import React from 'react'

import { Cell } from 'elements/layout/Cell'
import { Row } from 'elements/layout/Row'
import { Space } from 'elements/layout/Space'

import { Sidebar } from 'general/structure/Sidebar'

import { TCommunity } from 'modules/community/types'

import { CommunitySidebar } from './CommunitySidebar'

export const CommunityPageDesktopContent: TFCC<{
  community: TCommunity
}> = ({ children, community }) => (
  <>
    <Row gutter="1em">
      <Cell flex="1" minW="0px" m="0 auto">
        <Space noPrint />
        {children}
      </Cell>
      <Cell>
        <Sidebar>
          {({ distanceFromTop }) => <CommunitySidebar community={community} distanceFromTop={distanceFromTop} />}
        </Sidebar>
      </Cell>
    </Row>
  </>
)
